import * as React from 'react'
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

type Props = {
  title?: string
}

export function EditActivityStatusHeader(props: Props) {
  const { title } = props

  return (
    <Stack>
      <Stack direction="row" spacing={1} mb={1.4} alignItems="start">
        <Box pt="0px">
          <AssignmentOutlined color="primary" fontSize="small" />
        </Box>
        <Typography variant="h6" mr="auto!important" lineHeight="1">
          Subject: {title}
        </Typography>
      </Stack>
    </Stack>
  )
}
